import {
  BULK_ACTIONS,
  CREATE,
  DELETE,
  MANAGE,
  UPDATE,
  LIST_VIEW_CREATE,
  LIST_VIEW_DELETE,
  LIST_VIEW_DUPLICATE,
  LIST_VIEW_SHARE,
  LIST_VIEW_STAR,
  LIST_VIEW_UPDATE,
  LIST_VIEW_ADD_REMOVE_COLUMNS
} from 'permissions/actions'
import { userLevels } from 'permissions/userLevels'

export const PROJECT_MILESTONE = '@@permissions/policy/project_milestone'

export default {
  [BULK_ACTIONS]: (user, options) => !user.read_only && user.level !== userLevels.EXTERNAL,
  [CREATE]: (user, options) => !user.read_only,
  [DELETE]: (user, options) => !user.read_only,
  [MANAGE]: (user, options) => !user.read_only,
  [UPDATE]: (user, options) => !user.read_only,
  [LIST_VIEW_CREATE]: (user, options) => !user.read_only && !user.external,
  [LIST_VIEW_DELETE]: (user, options) => !user.read_only && !user.external,
  [LIST_VIEW_DUPLICATE]: (user, options) => !user.read_only && !user.external,
  [LIST_VIEW_SHARE]: (user, options) => !user.read_only || user.external,
  [LIST_VIEW_STAR]: (user, options) => !user.read_only,
  [LIST_VIEW_UPDATE]: (user, options) => !user.read_only,
  [LIST_VIEW_ADD_REMOVE_COLUMNS]: (user, options) => user.level !== userLevels.EXTERNAL
}
